import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import { Modal, Button, Icon, Loading, ConcreteColors, LoadingContainer, Col, Widget } from 'hcss-components';
import React__default, { useCallback, createElement } from 'react';
import createUseContext from 'constate';
import Axios from 'axios';
import Uppy from '@uppy/core';
import XHRUpload from '@uppy/xhr-upload';
import { SortingState, IntegratedSorting, SelectionState, IntegratedSelection } from '@devexpress/dx-react-grid';
import { Grid, VirtualTable, TableSelection, Table } from '@devexpress/dx-react-grid-bootstrap3';
import styled from 'styled-components';
import { DashboardModal } from '@uppy/react';

var SmartDriveAxiosInstance =
/*#__PURE__*/
function () {
  function SmartDriveAxiosInstance(_ref) {
    var token = _ref.token,
        appId = _ref.appId,
        url = _ref.url,
        _ref$root = _ref.root,
        root = _ref$root === void 0 ? "" : _ref$root;
    this.axios = Axios.create({
      baseURL: url,
      params: {
        isInternal: false,
        appId: appId,
        root: root
      },
      headers: {
        Authorization: "Bearer " + token
      }
    });
  }

  var _proto = SmartDriveAxiosInstance.prototype;

  _proto.loadFiles = function loadFiles() {
    return this.axios.get("/files/list");
  };

  _proto.downloadFile = function downloadFile(id) {
    return this.axios.get("/files", {
      params: {
        id: id
      },
      baseURL: this.axios.defaults.baseURL,
      responseType: "blob"
    });
  };

  _proto.deleteFile = function deleteFile(id) {
    return this.axios["delete"]("/files", {
      baseURL: this.axios.defaults.baseURL,
      params: {
        id: id
      }
    });
  };

  return SmartDriveAxiosInstance;
}();

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var initialState = {
  files: [],
  downloading: [],
  loading: true
};

function useSmartDriveReducer() {
  return React__default.useReducer(reducer, initialState);
}

function reducer(state, action) {
  switch (action.type) {
    case "setFiles":
      return _extends({}, state, {
        files: action.payload,
        loading: false
      });

    case "loadFiles":
      return _extends({}, state, {
        loading: true
      });

    case "updateFiles":
      return _extends({}, state, {
        files: mergeFiles(state.files, action.payload)
      });

    case "removeFile":
      return _extends({}, state, {
        files: state.files.filter(function (file) {
          return file.id !== action.payload;
        })
      });

    case "downloadFile":
      return _extends({}, state, {
        downloading: action.payload.isComplete ? state.downloading.filter(function (fileId) {
          return fileId !== action.payload.id;
        }) : [].concat(state.downloading, [action.payload.id])
      });

    default:
      return state;
  }
}

function createFileLookup(files) {
  var lookup = {};
  files.forEach(function (file) {
    lookup[file.id] = file;
  });
  return lookup;
}

function mergeFiles(existingFiles, newFiles) {
  var fileLookup = createFileLookup(existingFiles);
  var successLookup = createFileLookup(newFiles);
  newFiles = newFiles.filter(function (file) {
    return !(file.id in fileLookup);
  });
  existingFiles = existingFiles.map(function (file) {
    if (file.id in successLookup) {
      return successLookup[file.id];
    }

    return file;
  });
  return existingFiles.concat(newFiles);
}

// A type of promise-like that resolves synchronously and supports only one observer
var _iteratorSymbol =
/*#__PURE__*/
typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator =
/*#__PURE__*/
Symbol("Symbol.iterator")) : "@@iterator"; // Asynchronously iterate through an object's values
var _asyncIteratorSymbol =
/*#__PURE__*/
typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator =
/*#__PURE__*/
Symbol("Symbol.asyncIterator")) : "@@asyncIterator"; // Asynchronously iterate on a value using it's async iterator if present, or its synchronous iterator if missing

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
} // Asynchronously await a promise and pass the result to a finally continuation

function useSmartDriveApi(options) {
  var _useSmartDriveReducer = useSmartDriveReducer(),
      state = _useSmartDriveReducer[0],
      dispatch = _useSmartDriveReducer[1];

  var appId = options.appId,
      root = options.root,
      url = options.url,
      token = options.token;
  var api = React__default.useMemo(function () {
    return new SmartDriveAxiosInstance({
      appId: appId,
      root: root,
      url: url,
      token: token
    });
  }, [appId, root, url, token]); // Setup api instance

  var uploadUrl = options.url + "files" + ("?appId=" + options.appId) + ("&root=" + options.root) + ("&isInternal=" + (options.isInternal || false)) + ("&isShareable=" + (options.isShareable || false)); // Setup async actions

  var loadFilesAsync = React__default.useCallback(function () {
    try {
      var _temp2 = _catch(function () {
        dispatch({
          type: "loadFiles"
        });
        return Promise.resolve(api.loadFiles()).then(function (result) {
          dispatch({
            type: "setFiles",
            payload: result.data
          });
        });
      }, function (error) {
        var _error$response, _error$response2;

        dispatch({
          type: "setFiles",
          payload: []
        });
        options.onError({
          statusCode: error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status,
          statusText: error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.statusText
        });
        console.error(error);
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  }, [api, dispatch, options.onError]);
  var downloadFile = React__default.useCallback(function (file) {
    try {
      var _temp6 = function () {
        if (state.downloading.indexOf(file.id) === -1) {
          var _temp7 = function _temp7() {
            dispatch({
              type: "downloadFile",
              payload: {
                id: file.id,
                isComplete: true
              }
            });
          };

          var _temp8 = _catch(function () {
            dispatch({
              type: "downloadFile",
              payload: {
                id: file.id,
                isComplete: false
              }
            });
            return Promise.resolve(api.downloadFile(file.id)).then(function (_ref) {
              var data = _ref.data;
              // tslint:disable-next-line: deprecation
              return Promise.resolve(import('file-saver')).then(function (_ref2) {
                var saveAs = _ref2.saveAs;
                saveAs(data, file.fileName);
              });
            });
          }, function (error) {
            var _error$response3, _error$response4;

            options.onError({
              statusCode: error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status,
              statusText: error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.statusText
            });
            console.error(error);
          });

          return _temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8);
        }
      }();

      return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  }, [api, dispatch, options.onError, state.downloading]);
  var deleteFile = React__default.useCallback(function (fileId) {
    try {
      var _temp10 = _catch(function () {
        return Promise.resolve(api.deleteFile(fileId)).then(function () {
          dispatch({
            type: "removeFile",
            payload: fileId
          });
        });
      }, function (error) {
        var _error$response5, _error$response6;

        options.onError({
          statusCode: error === null || error === void 0 ? void 0 : (_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : _error$response5.status,
          statusText: error === null || error === void 0 ? void 0 : (_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : _error$response6.statusText
        });
        console.error(error);
      });

      return Promise.resolve(_temp10 && _temp10.then ? _temp10.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  }, [api, dispatch, options.onError]); // load files when mounted

  React__default.useEffect(function () {
    loadFilesAsync()["catch"](function (err) {
      console.error(err);
    });
  }, [loadFilesAsync]);
  return {
    files: state.files,
    loading: state.loading,
    downloading: state.downloading,
    dispatch: dispatch,
    downloadFile: downloadFile,
    deleteFile: deleteFile,
    baseUrl: options.url,
    uploadUrl: uploadUrl
  };
}

var uppyConfig = {
  id: "uppyFileUpload",
  autoProceed: false,
  debug: true,
  allowMultipleUploads: true,
  restrictions: {
    maxFileSize: 104857600,
    maxNumberOfFiles: 20,
    minNumberOfFiles: 1,
    allowedFileTypes: null
  }
};

function isDuplicateFile(filename, files) {
  return files.find(function (file) {
    return file.toUpperCase() === filename.toUpperCase();
  });
}
function getDuplicateFilename(filename, uploadedFilenames) {
  var newMatch = filename.match(/(.+)(\.[\w\d]+)$/i);
  var nameOnly = newMatch[1],
      extension = newMatch[2];
  var existingRegex = new RegExp(nameOnly + " \\((\\d+)\\)" + extension, "i");
  var maxNumber = uploadedFilenames.reduce(function (prev, curr) {
    var existingMatch = curr.match(existingRegex);

    if (existingMatch) {
      var numberText = existingMatch[1];
      var number = Number(numberText);
      if (number > prev) return number;
    }

    return prev;
  }, 0);
  return nameOnly + " (" + (maxNumber + 1) + ")" + extension;
}

function useUppy(_ref) {
  var token = _ref.token,
      endpoint = _ref.endpoint,
      currentFiles = _ref.currentFiles,
      onUploadComplete = _ref.onUploadComplete;
  var uppy = React__default.useRef();
  React__default.useEffect(function () {
    uppy.current = Uppy(_extends({}, uppyConfig)).use(XHRUpload, {
      endpoint: endpoint,
      method: "post",
      formData: true,
      fieldName: "files[]",
      metaFields: ["filename"],
      bundle: false,
      timeout: 30 * 1000,
      limit: 5,
      responseType: "",
      headers: {
        authorization: "Bearer " + token
      }
    });
    var uppyRef = uppy.current;
    return function () {
      uppyRef === null || uppyRef === void 0 ? void 0 : uppyRef.close();
    };
  }, [endpoint, token]);
  React__default.useEffect(function () {
    var uppyRef = uppy.current;

    if (uppyRef) {
      uppyRef.on("complete", function (result) {
        var successful = result.successful.map(function (file) {
          return file.response.body[0];
        });
        onUploadComplete(successful, result.failed.length > 0 ? {
          statusCode: result.failed[0].response.status,
          statusText: result.failed[0].error
        } : undefined);
      });
    }
  }, [onUploadComplete]);
  React__default.useEffect(function () {
    var uppyRef = uppy.current;

    if (uppyRef) {
      uppyRef.setOptions({
        onBeforeFileAdded: function onBeforeFileAdded(currentFile) {
          var existingFiles = currentFiles.map(function (file) {
            return file.fileName;
          });

          if (isDuplicateFile(currentFile.name, existingFiles)) {
            currentFile.name = getDuplicateFilename(currentFile.name, existingFiles);
          }

          return currentFile;
        }
      });
    }
  }, [currentFiles]);

  var _React$useState = React__default.useState(false),
      showUploadModal = _React$useState[0],
      setShowUploadModal = _React$useState[1];

  var toggleFileModal = React__default.useCallback(function (show) {
    setShowUploadModal(function (prev) {
      var nextState = show !== undefined ? show : !prev;

      if (!nextState && uppy.current) {
        uppy.current.reset();
      }

      return nextState;
    });
  }, []);
  return {
    instance: uppy.current,
    ui: {
      showUploadModal: showUploadModal,
      toggleFileModal: toggleFileModal
    }
  };
}

var useSmartDriveContext =
/*#__PURE__*/
createUseContext(function (_ref) {
  var appId = _ref.appId,
      root = _ref.root,
      url = _ref.url,
      isInternal = _ref.isInternal,
      isShareable = _ref.isShareable,
      isReadOnlyUser = _ref.isReadOnlyUser,
      getToken = _ref.getToken,
      onFilesChanged = _ref.onFilesChanged,
      onLinkCopied = _ref.onLinkCopied,
      onError = _ref.onError;
  var token = getToken();
  var api = useSmartDriveApi({
    appId: appId,
    root: root,
    token: token,
    url: url,
    isInternal: isInternal,
    isShareable: isShareable,
    isReadOnlyUser: isReadOnlyUser,
    onError: onError
  });
  var files = api.files,
      dispatch = api.dispatch;
  React__default.useEffect(function () {
    onFilesChanged && onFilesChanged(files);
  }, [files, onFilesChanged]);
  var uppySuccess = React__default.useCallback(function (success) {
    return dispatch({
      type: "updateFiles",
      payload: success
    });
  }, [dispatch]);
  var handleUpplyUploadComplete = React__default.useCallback(function (successful, failed) {
    uppySuccess(successful);

    if (failed) {
      onError(failed);
    }
  }, [onError, uppySuccess]);
  var uppy = useUppy({
    token: token,
    endpoint: api.uploadUrl,
    currentFiles: api.files,
    onUploadComplete: handleUpplyUploadComplete
  });

  var _React$useState = React__default.useState(),
      fileToDelete = _React$useState[0],
      setFileToDelete = _React$useState[1];

  var _React$useState2 = React__default.useState([]),
      selectedRowIds = _React$useState2[0],
      setSelectedRowIds = _React$useState2[1];

  var _React$useState3 = React__default.useState(),
      modalShowUp = _React$useState3[0],
      setModalShowUp = _React$useState3[1];

  return {
    api: api,
    isReadOnlyUser: isReadOnlyUser,
    uppy: uppy,
    actions: {
      onLinkCopied: onLinkCopied
    },
    fileOperations: {
      fileToDelete: fileToDelete,
      setFileToDelete: setFileToDelete
    },
    allSelectedRowsOperations: {
      selectedRowIds: selectedRowIds,
      setSelectedRowIds: setSelectedRowIds
    },
    delModalOperations: {
      modalShowUp: modalShowUp,
      setModalShowUp: setModalShowUp
    }
  };
});
var SmartDriveContext = useSmartDriveContext;

var SmartDriveDeleteAllFilesConfirmation = function SmartDriveDeleteAllFilesConfirmation() {
  var _useSmartDriveContext = useSmartDriveContext(),
      _useSmartDriveContext2 = _useSmartDriveContext.api,
      deleteFile = _useSmartDriveContext2.deleteFile,
      files = _useSmartDriveContext2.files,
      _useSmartDriveContext3 = _useSmartDriveContext.allSelectedRowsOperations,
      selectedRowIds = _useSmartDriveContext3.selectedRowIds,
      setSelectedRowIds = _useSmartDriveContext3.setSelectedRowIds,
      _useSmartDriveContext4 = _useSmartDriveContext.delModalOperations,
      modalShowUp = _useSmartDriveContext4.modalShowUp,
      setModalShowUp = _useSmartDriveContext4.setModalShowUp;

  var showModal = modalShowUp;
  return React__default.createElement(Modal, {
    show: showModal,
    onHide: function onHide() {
      return setModalShowUp(false);
    }
  }, React__default.createElement(Modal.Header, {
    closeButton: true
  }, React__default.createElement(Modal.Title, null, "Delete File(s)?")), React__default.createElement(Modal.Body, null, showModal && "Are you sure you want to delete " + (selectedRowIds && selectedRowIds.length > 0 ? selectedRowIds.map(function (id) {
    return files.filter(function (file) {
      return file.id === id;
    })[0].fileName;
  }).join(", ") : files.map(function (file) {
    return file.fileName;
  }).join(", ")) + " ?"), React__default.createElement(Modal.Footer, null, React__default.createElement(Button, {
    onClick: function onClick() {
      if (selectedRowIds && selectedRowIds.length > 0) {
        selectedRowIds.forEach(function (id) {
          deleteFile(id)["catch"](function (err) {
            console.error(err);
          });
        });
      } else {
        files.forEach(function (file) {
          return deleteFile(file.id)["catch"](function (err) {
            console.error(err);
          });
        });
      }

      setSelectedRowIds([]);
      setModalShowUp(false);
    },
    hcssStyle: "Delete"
  }, React__default.createElement(Icon, {
    name: "trash-o"
  }), "\xA0Confirm Delete"), React__default.createElement(Button, {
    hcssStyle: "ThemeInverted",
    onClick: function onClick() {
      return setModalShowUp(false);
    }
  }, React__default.createElement(Icon, {
    name: "times"
  }), "\xA0Cancel")));
};

var SmartDriveDeleteConfirmation = function SmartDriveDeleteConfirmation() {
  var _useSmartDriveContext = useSmartDriveContext(),
      deleteFile = _useSmartDriveContext.api.deleteFile,
      _useSmartDriveContext2 = _useSmartDriveContext.fileOperations,
      fileToDelete = _useSmartDriveContext2.fileToDelete,
      setFileToDelete = _useSmartDriveContext2.setFileToDelete,
      _useSmartDriveContext3 = _useSmartDriveContext.allSelectedRowsOperations,
      selectedRowIds = _useSmartDriveContext3.selectedRowIds,
      setSelectedRowIds = _useSmartDriveContext3.setSelectedRowIds;

  var showModal = fileToDelete !== undefined;
  return React__default.createElement(Modal, {
    show: showModal,
    onHide: function onHide() {
      return setFileToDelete(undefined);
    }
  }, React__default.createElement(Modal.Header, {
    closeButton: true
  }, React__default.createElement(Modal.Title, null, "Delete File?")), React__default.createElement(Modal.Body, null, showModal && "Are you sure you want to delete " + fileToDelete.fileName + "?"), React__default.createElement(Modal.Footer, null, React__default.createElement(Button, {
    onClick: function onClick() {
      if (fileToDelete) {
        deleteFile(fileToDelete.id).then(function () {
          var newSelectedRowIds = selectedRowIds.filter(function (rowId) {
            return rowId !== fileToDelete.id;
          });
          setSelectedRowIds(newSelectedRowIds);
        })["catch"](function (err) {
          console.error(err);
        });
        setFileToDelete(undefined);
      }
    },
    hcssStyle: "Delete"
  }, React__default.createElement(Icon, {
    name: "trash-o"
  }), "\xA0Confirm Delete"), React__default.createElement(Button, {
    hcssStyle: "ThemeInverted",
    onClick: function onClick() {
      return setFileToDelete(undefined);
    }
  }, React__default.createElement(Icon, {
    name: "times"
  }), "\xA0Cancel")));
};

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 4px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  justify-content: flex-end;\n  align-items: center;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: inherit;\n  border: none;\n  padding: none;\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var TableActionsCell = function TableActionsCell(_ref) {
  var row = _ref.row;

  var _useSmartDriveContext = useSmartDriveContext(),
      _useSmartDriveContext2 = _useSmartDriveContext.api,
      downloadFile = _useSmartDriveContext2.downloadFile,
      downloading = _useSmartDriveContext2.downloading,
      onLinkCopied = _useSmartDriveContext.actions.onLinkCopied,
      setFileToDelete = _useSmartDriveContext.fileOperations.setFileToDelete;

  var _useSmartDriveContext3 = useSmartDriveContext(),
      isReadOnlyUser = _useSmartDriveContext3.isReadOnlyUser;

  var isDownloading = downloading.indexOf(row.id) > -1;

  var handleCopyLink = function handleCopyLink() {
    var textField = document.createElement("textarea");
    textField.innerText = row.shareUrl;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    textField.remove();
    onLinkCopied && onLinkCopied();
  };

  var handleDownloadFile = function handleDownloadFile(e) {
    e.stopPropagation();
    downloadFile(row);
  };

  var handleDeleteFile = function handleDeleteFile(e) {
    e.stopPropagation();
    setFileToDelete(row);
  };

  return React__default.createElement("td", null, React__default.createElement(FileCell, null, React__default.createElement(ActionsArea, {
    style: {
      gridArea: "actions"
    }
  }, row.shareUrl && row.shareUrl.trim() !== "" && React__default.createElement(TableActionButton, {
    onClick: handleCopyLink
  }, React__default.createElement(Icon, {
    name: "clone"
  }), " Copy Link"), React__default.createElement(TableActionButton, {
    onClick: handleDownloadFile,
    disabled: isDownloading
  }, isDownloading ? React__default.createElement(Loading, {
    isLoading: isDownloading
  }) : React__default.createElement(Icon, {
    name: "download"
  }), " ", "Download"), React__default.createElement(TableActionButton, {
    disabled: isReadOnlyUser,
    color: "#9e0a0a",
    className: "delete",
    onClick: handleDeleteFile
  }, React__default.createElement(Icon, {
    name: "trash-o"
  }), " Delete"))));
};
var TableActionButton =
/*#__PURE__*/
styled.button(
/*#__PURE__*/
_templateObject(), function (props) {
  return props.disabled ? "707070" : props.color || "#005eb8";
});
var ActionsArea =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject2());
var FileCell =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject3());

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  grid-area: area;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-rows: auto;\n  grid-template-columns: 30px auto;\n  grid-template-areas: \"icon fileInfo\";\n  grid-gap: 12px;\n  padding: 4px;\n\n  .details {\n    width: 100%;\n  }\n\n  .size,\n  .date {\n    margin-right: 5px;\n    display: inline-block;\n    font-size: 0.9em;\n    color: #404040;\n  }\n\n  .size {\n    width: 8em;\n  }\n\n  .date {\n    width: 10em;\n  }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 2em;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var getSizeFormat = function getSizeFormat(bytes) {
  var suffix = [];
  suffix = ["B", "KB", "MB", "GB"];
  var index = 0;

  do {
    bytes /= 1024;
    index++;
  } while (bytes >= 1024);

  return bytes.toFixed(2) + " " + suffix[index];
};
var mimeIconMap = {
  // Media
  image: "file-image-o",
  audio: "file-audio-o",
  video: "file-video-o",
  // Documents
  "application/pdf": "file-pdf-o",
  "application/msword": "file-word-o",
  "application/vnd.ms-word": "file-word-o",
  "application/vnd.oasis.opendocument.text": "file-word-o",
  "application/vnd.openxmlformats-officedocument.wordprocessingml": "file-word-o",
  "application/vnd.ms-excel": "file-excel-o",
  "application/vnd.openxmlformats-officedocument.spreadsheetml": "file-excel-o",
  "application/vnd.oasis.opendocument.spreadsheet": "file-excel-o",
  "application/vnd.ms-powerpoint": "file-powerpoint-o",
  "application/vnd.openxmlformats-officedocument.presentationml": "file-powerpoint-o",
  "application/vnd.oasis.opendocument.presentation": "file-powerpoint-o",
  "text/plain": "file-text-o",
  "text/html": "file-code-o",
  "application/json": "file-code-o",
  "application/xml": "file-code-o",
  "application/octet-stream": "file-text-o",
  // Archives
  "application/gzip": "file-archive-o",
  "application/zip": "file-archive-o",
  "application/x-zip-compressed": "file-archive-o"
};

var getIconName = function getIconName(mimetype) {
  if (mimetype in mimeIconMap) {
    return mimeIconMap[mimetype];
  }

  return "file-o";
};

var FileIcon =
/*#__PURE__*/
styled(Icon)(
/*#__PURE__*/
_templateObject$1());
var TableFileCell = function TableFileCell(_ref) {
  var value = _ref.value,
      row = _ref.row;
  return React__default.createElement("td", null, React__default.createElement(FileCell$1, null, React__default.createElement(TableFlex, {
    style: {
      gridArea: "icon"
    }
  }, React__default.createElement(FileIcon, {
    name: getIconName(row.mime)
  })), React__default.createElement(TableFlex, {
    style: {
      gridArea: "fileInfo",
      justifyContent: "flex-start"
    }
  }, React__default.createElement("div", {
    className: "details"
  }, value), React__default.createElement("div", null, React__default.createElement("span", {
    className: "size"
  }, "Size: ", getSizeFormat(row.size)), React__default.createElement("span", {
    className: "date"
  }, "Uploaded:", " ", new Date(row.modified || row.created).toLocaleDateString())))));
};
var FileCell$1 =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject2$1());
var TableFlex =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject3$1());

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n\n  &:hover,\n  &:hover td {\n    background-color: #eee !important;\n  }\n\n  &.active,\n  &.active td {\n    background-color: #e3f1f8 !important;\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var SmartDriveGrid = function SmartDriveGrid(_ref) {
  var files = _ref.files,
      selection = _ref.selection,
      setSelection = _ref.setSelection;
  return React__default.createElement(Grid, {
    getRowId: getRowId,
    rootComponent: Root,
    rows: files,
    columns: columns
  }, React__default.createElement(SortingState, {
    defaultSorting: [{
      columnName: "fileName",
      direction: "asc"
    }]
  }), React__default.createElement(IntegratedSorting, null), React__default.createElement(SelectionState, {
    selection: selection,
    // @ts-ignore
    onSelectionChange: setSelection
  }), React__default.createElement(IntegratedSelection, null), React__default.createElement(VirtualTable, {
    tableComponent: STable,
    height: "auto",
    cellComponent: Cell,
    columnExtensions: [{
      columnName: "actions",
      width: 300
    }]
  }), React__default.createElement(TableSelection, {
    highlightRow: true,
    selectByRowClick: true,
    // @ts-ignore
    rowComponent: StyledSelectionRow
  }));
}; // @ts-ignore
// https://github.com/DevExpress/devextreme-reactive/issues?utf8=%E2%9C%93&q=is%3Aissue+is%3Aopen+rowcomponent

var StyledSelectionRow =
/*#__PURE__*/
styled(TableSelection.Row)(
/*#__PURE__*/
_templateObject$2());
var columns = [{
  name: "fileName",
  title: "Name"
}, {
  name: "actions",
  title: ""
}];

var STable = function STable(props) {
  return React__default.createElement(VirtualTable.Table, Object.assign({}, props, {
    style: {
      borderCollapse: "collapse"
    }
  }));
};

var getRowId = function getRowId(row) {
  return row.id;
};

var Root = function Root(props) {
  return React__default.createElement(Grid.Root, Object.assign({}, props));
};

var Cell = function Cell(props) {
  var column = props.column;

  switch (column.name) {
    case "fileName":
      return React__default.createElement(TableFileCell, Object.assign({}, props));

    case "actions":
      return React__default.createElement(TableActionsCell, Object.assign({}, props));

    default:
      return React__default.createElement(Table.Cell, Object.assign({}, props));
  }
};

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  padding: 40px 0px;\n  border-radius: 5px;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var TablePlaceholder = function TablePlaceholder(_ref) {
  var name = _ref.name,
      isReadOnlyUser = _ref.isReadOnlyUser,
      onClick = _ref.onClick;
  return React__default.createElement(Placeholder, null, React__default.createElement(Button, {
    onClick: onClick,
    disabled: isReadOnlyUser
  }, !isReadOnlyUser && React__default.createElement(Icon, {
    name: "plus",
    style: {
      marginRight: 5
    }
  }), name));
};
var Placeholder =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$3(), ConcreteColors.gray300);

var SmartDriveTable = function SmartDriveTable() {
  var _useSmartDriveContext = useSmartDriveContext(),
      _useSmartDriveContext2 = _useSmartDriveContext.api,
      files = _useSmartDriveContext2.files,
      loading = _useSmartDriveContext2.loading,
      downloadFile = _useSmartDriveContext2.downloadFile,
      _useSmartDriveContext3 = _useSmartDriveContext.allSelectedRowsOperations,
      selectedRowIds = _useSmartDriveContext3.selectedRowIds,
      setSelectedRowIds = _useSmartDriveContext3.setSelectedRowIds,
      setModalShowUp = _useSmartDriveContext.delModalOperations.setModalShowUp,
      toggleFileModal = _useSmartDriveContext.uppy.ui.toggleFileModal,
      isReadOnlyUser = _useSmartDriveContext.isReadOnlyUser;

  var handleUploadFilesClick = useCallback(function () {
    toggleFileModal(true);
  }, [toggleFileModal]);
  return React__default.createElement(LoadingContainer, {
    isLoading: loading
  }, files.length === 0 ? React__default.createElement(TablePlaceholder, {
    name: isReadOnlyUser ? "No files to display" : "Upload Files",
    onClick: handleUploadFilesClick,
    isReadOnlyUser: isReadOnlyUser
  }) : React__default.createElement(React__default.Fragment, null, React__default.createElement(Col, {
    sm: 12
  }, React__default.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "wrap"
    }
  }, React__default.createElement(Button, {
    onClick: handleUploadFilesClick,
    style: {
      marginBottom: "10px"
    },
    disabled: isReadOnlyUser
  }, React__default.createElement(Icon, {
    name: "upload",
    style: {
      marginRight: 5
    }
  }), "Upload Files"), React__default.createElement("div", {
    style: {
      marginLeft: "auto"
    }
  }, React__default.createElement(Button, {
    hcssStyle: "ThemeInverted",
    onClick: handleDownloadAllFilesClick,
    style: {
      marginBottom: "10px",
      marginRight: "20px"
    }
  }, "Download", " ", selectedRowIds && selectedRowIds.length > 0 ? "Selected" : "All"), React__default.createElement(Button, {
    hcssStyle: "ThemeInverted",
    onClick: handleDeleteAllFilesClick,
    style: {
      marginBottom: "10px"
    },
    disabled: isReadOnlyUser
  }, "Delete", " ", selectedRowIds && selectedRowIds.length > 0 ? "Selected" : "All")))), React__default.createElement(SmartDriveGrid, {
    files: files,
    selection: selectedRowIds || [],
    setSelection: setSelectedRowIds
  })));

  function handleDownloadAllFilesClick() {
    if (selectedRowIds && selectedRowIds.length > 0) {
      selectedRowIds.forEach(function (id) {
        downloadFile(files.filter(function (file) {
          return file.id === id;
        })[0]);
      });
    } else {
      files.forEach(function (file) {
        return downloadFile(file);
      });
    }
  }

  function handleDeleteAllFilesClick() {
    setModalShowUp(true);
  }
};

var SmartDriveUploadModal = function SmartDriveUploadModal() {
  var _useSmartDriveContext = useSmartDriveContext(),
      _useSmartDriveContext2 = _useSmartDriveContext.uppy,
      instance = _useSmartDriveContext2.instance,
      ui = _useSmartDriveContext2.ui;

  if (!instance) {
    return null;
  }

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(UppyDummyTrigger, null), React__default.createElement(DashboardModal, {
    trigger: "#uppy-select-files",
    uppy: instance,
    open: ui.showUploadModal,
    onRequestClose: function onRequestClose() {
      return ui.toggleFileModal(false);
    },
    locale: {
      strings: {
        dropPaste: "Drop files here, or %{browse}"
      }
    }
  }));
}; // This is just so we don't get the console error from uppy

var UppyDummyTrigger = function UppyDummyTrigger() {
  return React__default.createElement("div", {
    style: {
      display: "none"
    },
    id: "uppy-select-files"
  });
};

var TableFlex$1 = function TableFlex(_ref) {
  var style = _ref.style,
      children = _ref.children,
      area = _ref.area;

  var flexStyle = _extends({
    gridArea: area,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap"
  }, style);

  return createElement("div", {
    style: flexStyle
  }, children);
};

var SmartDriveWidget = function SmartDriveWidget(_ref) {
  var title = _ref.title,
      options = _objectWithoutPropertiesLoose(_ref, ["title"]);

  return React__default.createElement(SmartDriveContext.Provider, Object.assign({}, options), React__default.createElement(Widget, null, React__default.createElement(Widget.Header, null, React__default.createElement(Widget.Title, null, title)), React__default.createElement(Widget.Body, null, React__default.createElement(SmartDriveTable, null))), React__default.createElement(SmartDriveUploadModal, null), React__default.createElement(SmartDriveDeleteConfirmation, null), React__default.createElement(SmartDriveDeleteAllFilesConfirmation, null));
};

var SmartDriveContextDocs = function SmartDriveContextDocs(_ref) {
  var children = _ref.children,
      options = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return React__default.createElement(SmartDriveContext.Provider, Object.assign({}, options), children);
};
var TestSmartDriveContext = function TestSmartDriveContext(_ref2) {
  var root = _ref2.root,
      children = _ref2.children;
  return React__default.createElement(SmartDriveContext.Provider, {
    appId: "3EF4C10A-746E-454D-A69A-798E00513C31",
    root: root,
    getToken: function getToken() {
      return "TestToken";
    },
    url: "https://smartdrive-dev.azurewebsites.net/api/test/"
  }, children);
};
var CustomFileList = function CustomFileList() {
  var _useSmartDriveContext = useSmartDriveContext(),
      api = _useSmartDriveContext.api,
      uppy = _useSmartDriveContext.uppy;

  if (api.loading) {
    return React__default.createElement("div", null, "loading");
  }

  return React__default.createElement("div", null, React__default.createElement("h4", null, "File List"), api.files.length > 0 ? api.files.map(function (file) {
    return React__default.createElement("li", {
      key: file.id
    }, React__default.createElement("span", {
      style: {
        marginRight: "32px"
      }
    }, file.fileName), React__default.createElement(Button, {
      onClick: function onClick() {
        return api.downloadFile(file);
      }
    }, "download"), React__default.createElement(Button, {
      onClick: function onClick() {
        return api.deleteFile(file.id);
      }
    }, "delete"));
  }) : React__default.createElement("p", null, "No files"), React__default.createElement("button", {
    onClick: function onClick() {
      return uppy.ui.toggleFileModal();
    }
  }, "upload files"));
};

var TestSmartDriveWidget = function TestSmartDriveWidget(_ref) {
  var root = _ref.root,
      title = _ref.title;
  return React__default.createElement(TestSmartDriveContext, {
    root: root
  }, React__default.createElement(Widget, null, React__default.createElement(Widget.Header, null, React__default.createElement(Widget.Title, null, title)), React__default.createElement(Widget.Body, null, React__default.createElement(SmartDriveTable, null))), React__default.createElement(SmartDriveUploadModal, null), React__default.createElement(SmartDriveDeleteConfirmation, null), React__default.createElement(SmartDriveDeleteAllFilesConfirmation, null));
};

export { CustomFileList, SmartDriveAxiosInstance, SmartDriveContext, SmartDriveContextDocs, SmartDriveDeleteAllFilesConfirmation, SmartDriveDeleteConfirmation, SmartDriveGrid, SmartDriveTable, SmartDriveUploadModal, SmartDriveWidget, StyledSelectionRow, TableActionsCell, TableFileCell, TableFlex$1 as TableFlex, TablePlaceholder, TestSmartDriveContext, TestSmartDriveWidget, getDuplicateFilename, getSizeFormat, initialState, isDuplicateFile, uppyConfig, useSmartDriveApi, useSmartDriveContext, useSmartDriveReducer, useUppy };
//# sourceMappingURL=hcss-smartdrive.esm.js.map
